import React, { useEffect, useState } from 'react';
import { TroubleshootGuideService } from '../../../core/services/troubleshoot-guide.service';
import { TROUBLESHOOT_GUIDE_DRAWER_CLOSE_CLICK } from '../../tracking/troubleshootDrawerTracking';
import { TroubleshootGuide } from '../../../docs/components/troubleshoot-guide/TroubleshootGuide';
import { HdIcon, HdIconButton } from '../../../components';
import useAnalyticsTracker from '../../../analytics/hooks/useAnalyticsTracker';
import useService from '../../../injector/hooks/useService';
import { getDataIdGenerator } from '../../../core/utils/generateDataId';
import { DrawerWrapper } from '../../../drawer/components/drawer-wrapper/DrawerWrapper';
import { ReactDrawerBaseProps } from '../../../drawer/interfaces/drawer';
import { useHideDrawer } from '../../../drawer/hooks/useHideDrawer';
import styles from './TroubleshootDrawer.module.scss';

export function TroubleshootDrawer({
  drawerDirection,
  disableRestoreFocus,
  usingReactRouter,
  closeInitiated,
  springValues
}: ReactDrawerBaseProps) {
  const [ troubleshootLink, setTroubleshootLink ] = useState(null);

  const { hideDrawer } = useHideDrawer();
  const { eventTrack } = useAnalyticsTracker();

  const troubleshootGuideService = useService(TroubleshootGuideService);

  const hide = () => {
    troubleshootGuideService.setTroubleshootVisibleStatus(false);
    hideDrawer();
  };

  const onCloseClick = () => {
    eventTrack({
      action: TROUBLESHOOT_GUIDE_DRAWER_CLOSE_CLICK,
      properties: {
        docLink: troubleshootLink
      }
    });

    hide();
  };

  useEffect(() => {
    const sub = troubleshootGuideService.troubleshootLink$.subscribe((link) => {
      setTroubleshootLink(link);
    });

    return () => {
      sub.unsubscribe();
    };
  }, []);

  const dataIdGenerator = getDataIdGenerator('troubleshoot-guide-drawer');

  return (
    <DrawerWrapper
      className={styles.troubleshootDrawer}
      drawerDirection={drawerDirection}
      closeInitiated={closeInitiated}
      disableRestoreFocus={disableRestoreFocus}
      usingReactRouter={usingReactRouter}
      springValues={springValues}
      hide={hide}
    >
      <div className='py-4 px-5'>
        <div className='center-flex-row justify-between'>
          <div className='drawer-title text-transform-none'>
            Troubleshooting Guide
          </div>

          <HdIconButton
            dataId={dataIdGenerator('close')}
            className='ml-3'
            onClick={onCloseClick}
          >
            <HdIcon name='close' size={2} />
          </HdIconButton>
        </div>
      </div>

      <div className='drawer-body'>
        <TroubleshootGuide
          docLink={troubleshootLink}
        />
      </div>
    </DrawerWrapper>
  );
}
